import {STATE_PROP_NAME} from './storyline-modal-constants'

export const getStorylineModalState = state => state[STATE_PROP_NAME]
